// @flow

import React, { useEffect, useRef, useState } from 'react';
import Modal from '../../Modal2';
import t from '../../../i18n/I18n';
import './NewBinModal.css';
import { ThemeSetup } from '../../../themes/ThemeSetup';
import { Img } from '../../../common/elements';
import { Button, Dropdown } from '../../../common';

import _ from 'lodash';
import DropdownSearch from '../../../common/form/dropdown-search/DropdownSearch';
import CollectionModalV2 from '../collection-modal-v2/CollectionModalV2';
import CollectionUtil from '../../../queries/lightbox/CollectionUtil';
import SetCollectionMetadata from '../../../queries/lightbox/metadata/SetCollectionMetadata';
import SearchUtil from '../../../util/SearchUtil';
import { toast } from '../../../store/StoreUtil';
import SearchOption from '../../../common/form/dropdown-search/SearchOption';
import ThumbnailUtil from '../../../util/ThumbnailUtil';
import { COLLECTIONS } from '../../../store/Constants';
import ViewUtil from '../../../ViewUtil';
import Store from '../../../store/Store';

import { treeEmitter } from '../../../tabs/collections/CollectionsTree';
import { Checkbox } from '../../../common/form';
import StringUtil from '../../../util/StringUtil';
import { async } from 'regenerator-runtime';

const NewBinModal = ({ collections, onClose, onSubmit, reloadCollection, parentBin = null }) => {
  const [binName, setBinName] = useState('');
  const [binNameError, setBinNameError] = useState(null);

  const [childCollectionName, setChildCollectionName] = useState('');
  const [collectionOptions, setCollectionOptions] = useState([]);
  const [selectedCollections, setSelectedCollections] = useState(collections ? getCollectionIds(collections) : []);
  const [defaultDropdownColls, setDefaultDropdownColls] = useState(collections ? getDefaultDropDownOptions(false) : undefined);
  const [childCollectionError, setChildCollectionError] = useState(null);

  const [childBinName, setChildBinName] = useState('');
  const [binOptions, setBinOptions] = useState([]);
  const [selectedBins, setSelectedBins] = useState(collections ? getCollectionIds(collections, true) : []);
  const [defaultDropdownBins, setDefaultDropdownBins] = useState(collections ? getDefaultDropDownOptions(true) : undefined);
  const [childBinError, setChildBinError] = useState(null);

  const [haveParent, setHaveParent] = useState(parentBin ? true : false);
  const [parentBinOptions, setParentBinOptions] = useState([]);
  const [selectedParentBinOption, setSelectedParentBinOption] = useState(parentBin ? getOptionFromCollection(parentBin) : null);
  const [parentBinError, setParentBinError] = useState(null);
  const [parentBinId, setParentBinId] = useState(parentBin ? parentBin.getCollectionId() : CollectionUtil.ROOT_COLLECTION_ID);
  const [parentBinName, setParentBinName] = useState(selectedParentBinOption ? selectedParentBinOption.getName() : '');

  function forbiddenCharsCheck(inputString) {
    const forbiddenChars = /[\/\\\n"]/;
    return forbiddenChars.test(inputString);
  }

  function getDefaultDropDownOptions(bins) {
    var ddColls = [];
    if (collections) {
      if (!bins) {
        collections.forEach(coll => {
          if (!CollectionUtil.isBinCollection(coll)) {
            let searchOption = new SearchOption().setId(coll.getCollectionId())
              .setName(coll.getName()).setThumbnailSrc('images/icons_all_coll.svg');
            ddColls.push(searchOption);
          }
        });
      }
      else {
        collections.forEach(coll => {
          if (CollectionUtil.isBinCollection(coll)) {
            let searchOption = new SearchOption().setId(coll.getCollectionId())
              .setName(coll.getName()).setThumbnailSrc('images/icons_all_coll.svg');
            ddColls.push(searchOption);
          }
        });
      }
    }
    return ddColls;
  }

  function getCollectionIds(collections, bins = false) {
    var ids = [];
    if (bins) {
      collections.forEach(coll => {
        if (CollectionUtil.isBinCollection(coll))
          ids.push(coll.getCollectionId())
      });
    } else {
      collections.forEach(coll => {
        if (!CollectionUtil.isBinCollection(coll))
          ids.push(coll.getCollectionId())
      });
    }
    return ids;
  }

  const onBinNameChange = (e) => {
    const value = e.target ? e.target.value : '';
    setBinName(value);

    if (!value || value.trim() === '') {
      setBinNameError(t('NEW_BIN_MODAL.BIN_NAME_EMPTY_ERROR'));
    }
    else if (forbiddenCharsCheck(value)) {
      setBinNameError(t('NEW_BIN_MODAL.FORBIDDEN_CHAR_ERROR'));
    }
    else {
      /*SearchUtil.searchCollections(value, true, false).then((resp) => {
        const matchedBins = resp.getMatchedCollection() ?
          resp.getMatchedCollection().filter(collection => StringUtil.equals(collection.getName(), value)) : null;

        if (matchedBins && matchedBins.length) {
          setBinNameError(t('NEW_BIN_MODAL.BIN_NAME_EXIST_ERROR'));
        } else {
          setBinNameError(undefined);
        }
      }).catch((err) => {
        console.log(err);
      });*/

      setBinNameError(undefined);
    }
  };

  const toggleParentState = (e) => {
    if (haveParent) {
      setParentBinId(CollectionUtil.ROOT_COLLECTION_ID);
      setSelectedParentBinOption(null);
      setParentBinName('');
    }
    setHaveParent(!haveParent);
  };

  const handleParentSelected = (selectedBinId) => {
    setParentBinId(selectedBinId);
  };

  const addSelectedBin = (selectedBinId) => {
    if (!selectedBins.some((binId) => binId === selectedBinId)) {
      setSelectedBins([...selectedBins, selectedBinId]);
    }
  };

  const removeSelectedBin = (selectedBinId) => {
    setSelectedBins(selectedBins.filter(binId => binId !== selectedBinId));
  };

  const addSelectedCollection = (selectedCollectionId) => {
    if (!selectedCollections.some((collectionId) => collectionId === selectedCollectionId)) {
      setSelectedCollections([...selectedCollections, selectedCollectionId]);
    }
  };

  const removeSelectedCollection = (selectedCollectionId) => {
    setSelectedCollections(selectedCollections.filter(collectionId => collectionId !== selectedCollectionId));
  };

  const handleCollectionInputChange = (value) => {
    setChildCollectionError(null);
    setChildCollectionName(value);
    const autoSearch = SearchUtil.searchCollectionAutoComplete(value, false, true);
    autoSearch.then((resp) => { setCollectionOptions(getOptionsFromCollections(resp.getMatchedCollection())) });
  };

  const handleBinInputChange = (value) => {
    setChildBinError(null);
    setChildBinName(value);
    const autoSearch = SearchUtil.searchCollectionAutoComplete(value, true, false);
    autoSearch.then((resp) => setBinOptions(getOptionsFromCollections(resp.getMatchedCollection())));
  };

  const handleParentBinChange = (value) => {
    setParentBinError(null);
    setParentBinName(value);
    setParentBinId(CollectionUtil.ROOT_COLLECTION_ID);
    const autoSearch = SearchUtil.searchCollectionAutoComplete(value, true, false);
    autoSearch.then((resp) => setParentBinOptions(getOptionsFromCollections(resp.getMatchedCollection())));
  };

  function getCollectionThumbnail(collectionId) {
    /*ThumbnailUtil.getThumnailUrl(
      true,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      collectionId > 0 ? collectionId : 0
    )*/
    return 'images/icons_all_coll.svg';
  }

  function getOptionFromCollection(collectionOption) {
    return new SearchOption().setId(collectionOption.getCollectionId())
      .setName(collectionOption.getName()).setThumbnailSrc(getCollectionThumbnail(collectionOption.getCollectionId()));
  };

  const getOptionsFromCollections = (collectionOptions) => {
    let options: Array<SearchOption> = [];
    if (collectionOptions && collectionOptions.length) {
      for (const collectionOption of collectionOptions) {
        let searchOption = getOptionFromCollection(collectionOption);
        options.push(searchOption);
      }
    }
    return options;
  };

  const getChildCollectionsList = () => {
    return [...selectedBins, ...selectedCollections];
  };

  const validateBin = () => {
    if (binNameError) {
      return false;
    }

    if (haveParent) {
      if (StringUtil.isEmpty(parentBinName)) {
        setParentBinError(t('NEW_BIN_MODAL.PARENT_BIN_EMPTY'));
        return false;
      }
      else if (parentBinId <= 0) {
        setParentBinError(t('NEW_BIN_MODAL.SELECT_VALID_PARENT'));
        return false;
      }
    }

    if (!StringUtil.isEmpty(childBinName) && (selectedBins && selectedBins.length === 0)) {
      setChildBinError(t('NEW_BIN_MODAL.ADD_VALID_BINS'));
      return false;
    }

    if (!StringUtil.isEmpty(childCollectionName) && (selectedCollections && selectedCollections.length === 0)) {
      setChildCollectionError(t('NEW_BIN_MODAL.ADD_VALID_COLLECTIONS'));
      return false;
    }

    return true;
  }

  const createBin = () => {
    if (!validateBin())
      return;
    CollectionUtil.createBin(binName, parentBinId, selectedCollections, selectedBins)
      .then(binId => {
        toast(t('COLLECTION_ADDED'));
        if (onSubmit)
          onSubmit(binId);
        /*else
          switchToNewBin(binId);*/
        else
          reloadCollection();
        if (onClose)
          onClose();
      })
      .catch(error => {
        console.log(error);
        if (error.errorDetails && error.errorDetails.length > 0) toast(error.errorDetails);
        else toast(error.statusText);
      });
  };

  const switchToNewBin = (binId) => {
    CollectionUtil.getCollection(binId, (zmCollection, errorId) => {
      if (zmCollection) {
        let collections = Store.get(COLLECTIONS);
        collections = [...collections, zmCollection];
        Store.put(COLLECTIONS, collections);
        ViewUtil.switchToCollectionId(zmCollection.getCollectionId());
      } else {
        window.setError(errorId.toString());
      }
    });
  };

  return (
    <CollectionModalV2
      title={t('NEW_BIN_MODAL.CREATE_BIN')}
      onClose={onClose}
      onOk={createBin}
      name="NewBinModal"
      okBtnText={t('NEW_BIN_MODAL.CREATE_BIN')}>
      <div>
        <div className={'new-bin-modal-input-wrapper'}>
          <label htmlFor="bin-name" className="new-bin-modal-label">
            {t('NEW_BIN_MODAL.NAME_BIN')}
          </label>
          <input
            className={`full-width ${binNameError ? 'new-bin-modal-input-error' : ''}`}
            name="bin-name"
            type="text"
            value={binName}
            onChange={(e) => onBinNameChange(e)}
          />
          {binNameError && <p className="new-bin-modal-error-text">{binNameError}</p>}
        </div>
        <Checkbox
          className="choose-bin-label"
          checked={haveParent}
          label={t('NEW_BIN_MODAL.ADD_TO_BIN_CHECKBOX_LBL')}
          onChange={toggleParentState}
        />
        {
          haveParent && !window.gs.isExternalUser ? (
            <div className={'collection-input-wrapper'}>
              <label htmlFor="collection-bin" className="collection-label">
                {t('NEW_BIN_MODAL.CHOOSE_BIN_LBL')}
              </label>
              <DropdownSearch
                placeholder={t('NEW_BIN_MODAL.PARENT_BIN_PLACEHOLDER')}
                isSingleSelect={true}
                options={parentBinOptions}
                onOptionSelect={handleParentSelected}
                onInputChange={handleParentBinChange}
                defaultOptions={selectedParentBinOption ? [selectedParentBinOption] : []}
              />
              {parentBinError ? <p className="new-bin-modal-error-text">{parentBinError}</p> : null}
            </div>
          ) : null
        }

        <div className="new-bin-modal-input-wrapper">
          <label htmlFor="add-collection" className="new-bin-modal-label">
            {t('NEW_BIN_MODAL.ADD_BIN')}
          </label>
          <DropdownSearch
            placeholder={t('NEW_BIN_MODAL.ADD_BIN_PLACEHOLDER')}
            options={binOptions}
            onOptionSelect={addSelectedBin}
            onOptionRemove={removeSelectedBin}
            onInputChange={handleBinInputChange}
            defaultOptions={defaultDropdownBins}
          />
          {childBinError && <p className="new-bin-modal-error-text">{childBinError}</p>}
        </div>
        <div className="new-bin-modal-input-wrapper">
          <label htmlFor="add-collection" className="new-bin-modal-label">
            {t('NEW_BIN_MODAL.ADD_COLLECTION')}
          </label>
          <DropdownSearch
            placeholder={t('NEW_BIN_MODAL.ADD_COLLECTION_PLACEHOLDER')}
            options={collectionOptions}
            onOptionSelect={addSelectedCollection}
            onOptionRemove={removeSelectedCollection}
            onInputChange={handleCollectionInputChange}
            defaultOptions={defaultDropdownColls}
          />
          {childCollectionError && <p className="new-bin-modal-error-text">{childCollectionError}</p>}
        </div>
      </div>
    </CollectionModalV2>
  );
};

export default NewBinModal;
